import { createContext, useContext, useState, useCallback } from 'react';

const RequestStatusContext = createContext();

export function RequestStatusProvider({ children }) {
  const [status, setStatus] = useState(null); // { type: 'success' | 'error', message: '...' }

  const showSuccess = useCallback((message = 'Запрос выполнен успешно') => {
    setStatus({ type: 'success', message });
    setTimeout(() => setStatus(null), 3000);
  }, []);

  const showError = useCallback((error) => {
    const message =
      typeof error === 'string'
        ? error
        : error?.response
        ? `Ошибка ${error.response.status}: ${JSON.stringify(error.response.data)}`
        : 'Неизвестная ошибка';

    setStatus({ type: 'error', message });
    setTimeout(() => setStatus(null), 5000);
  }, []);

  return (
    <RequestStatusContext.Provider value={{ status, showSuccess, showError }}>
      {children}
    </RequestStatusContext.Provider>
  );
}

export function useRequestStatus() {
  return useContext(RequestStatusContext);
}
